module.exports = __webpack_public_path__ + "static/media/trashIcon.51ce9680.svg";